import angular from 'angular';
import providerUploadDocuments from './providerUploadDocuments';
import './style.scss';

export default angular
  .module('components.providerUploadDocuments', [])
  .component('providerUploadDocuments', providerUploadDocuments).name;
